import React from 'react'
import { cn } from '../../lib/utils'
// import { Separator } from '../ui/separator'
import { SidebarTrigger } from '../ui/sidebar'

interface HeaderProps extends React.HTMLAttributes<HTMLElement> {
  fixed?: boolean
  ref?: React.Ref<HTMLElement>
}

export const Header = ({
  className,
  fixed,
  children,
  ...props
}: HeaderProps) => {
  const [offset, setOffset] = React.useState(0)

  React.useEffect(() => {
    const onScroll = () => {
      setOffset(document.body.scrollTop || document.documentElement.scrollTop)
    }

    // Add scroll listener to the body
    document.addEventListener('scroll', onScroll, { passive: true })

    // Clean up the event listener on unmount
    return () => document.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <header
      className={cn(
        'flex h-16 items-center gap-3 bg-white p-4 sm:gap-4 w-[90%] shadow-md mt-2',
        fixed && 'header-fixed peer/header fixed z-50 rounded-md',
        offset > 10 && fixed ? 'shadow' : '',
        className
      )}
      {...props}
    >
      <SidebarTrigger variant='outline' className='scale-125 sm:scale-100' />
      {/* <Separator orientation='vertical' className='h-6 bg-gray-200' /> */}
      {children}
    </header>
  )
}

Header.displayName = 'Header'
